import { isObjectEmpty } from "../CommonUtils"
import { extendLocationData } from "../ExtendedDataUtils"
import { getUserSavedAddress } from "../user/UserAddressUtils"
import { updateUserSelectedLocationToRedux } from "../redux/commonRedux"
import { UserSavedAddressSubscription } from "../subject-behaviour/CommonRxjsService"

export const getAddressFromUserSavedLocation = (addressReference) => {
    UserSavedAddressSubscription.getSavedAddress().
        subscribe((addressData) => {
            if (addressData['hasFetched']) {
                let addressList = addressData['addressList'] ?? []
                let selectedLocation = {}
                addressList.forEach((address) => {
                    if (address['aid'] == addressReference['aid']) {
                        selectedLocation = extendLocationData(addressReference, {})
                        return
                    }
                })
                // Fix this. in case of reorder, and address is deleted will be passed this location.
                if (isObjectEmpty(selectedLocation))
                    selectedLocation = extendLocationData(addressReference,
                        { isSavedLocation: true, isAddressDeleted: true })
                updateUserSelectedLocationToRedux(selectedLocation)
            } else getUserSavedAddress()
        })
}

export const isAddressUpdated = ({ oldLocation, newLocation }) => {
    if (isObjectEmpty(oldLocation)) return true
    if (oldLocation['isAddressCompleted'] ^ newLocation['isAddressCompleted'])
        return true
    else if (oldLocation['isAddressCompleted'] &&
        oldLocation['aid'] == newLocation['aid']) return false
    else if (oldLocation['pid'] == newLocation['pid']) return false
    else return true
}

export function getSelectedLocationTitle(location) {
    let title = 'Select location'
    if (location['isAddressCompleted']) {
        title = location['name']
    } else title = location['locationTitle']
    return title
}